import * as api from '../../../../api/masters/company/companyApi';
import * as types from '../../../types/masters/company/companyTypes';

export const fetchCompanies = () => async (dispatch) => {
  dispatch({ type: 'FETCH_COMPANIES_REQUEST' });
  try {
    const companies = await api.fetchCompanies();
    dispatch({ type: 'FETCH_COMPANIES_SUCCESS', payload: companies });
  } catch (error) {
    dispatch({ type: 'FETCH_COMPANIES_FAILURE', error: error.message });
  }
};

export const addCompany = (company) => async (dispatch) => {
  const newCompany = await api.addCompany(company);
  dispatch({ type: types.ADD_COMPANY_SUCCESS, payload: newCompany });
  dispatch(fetchCompanies());
};

export const updateCompany = ({ id, company }) => async (dispatch) => {
  const updated = await api.updateCompany(id, company);
  dispatch({ type: types.UPDATE_COMPANY_SUCCESS, payload: updated });
  dispatch(fetchCompanies());
};

export const deleteCompany = (id) => async (dispatch) => {
  await api.deleteCompany(id);
  dispatch({ type: types.DELETE_COMPANY_SUCCESS, payload: id });
  dispatch(fetchCompanies());
};

export const setCompanyEdit = (company) => ({ type: types.SET_COMPANY_EDIT, payload: company });
export const clearCompanyEdit = () => ({ type: types.CLEAR_COMPANY_EDIT }); 